/**
 * The `test` stage. Built by `npm run build:test`, deployed to the test Cloudflare Pages projects.
 *
 * Only test values belong in this file: `angular.json` swaps `stage.ts` for this one, so whatever is here
 * is what ships, and no other stage's addresses are in the bundle. See `stage.model.ts`.
 */
import { StageConfig } from './stage.model';

export const STAGE: StageConfig = {
  name: 'test',
  production: true,
  BASE_URL: 'https://testpartnerapi.lifemaan.com/',
  IMAGE_BASE_URL: 'https://testpartnerapi.lifemaan.com/',
  // Console left usable on test on purpose, so a tester can read it on a real deployment.
  PATIENT_SITE_URL: 'https://testlifecard.lifemaan.com',
  SILENCE_CONSOLE: false,
  GRAPHICS_COMPRESSION_REWORK_ENABLED: true,
  OTP_RESEND_SECONDS: 30,
};
